import { ENTERPRISE_ADLE_MODULE_VALUES } from "../../utils/constants";
import {
  MODULE_VALUE_TO_PREFIX,
  shouldShowModuleCard,
} from "./enterpriseIntakeModuleUtils";
import { enterpriseIntakeDefaultValues } from "./enterpriseIntakeDefaultValues";

export { enterpriseIntakeDefaultValues };

export const getEnterpriseIntakeModuleVisibility = ({
  selectedAdleModules,
  formValues,
  readOnly,
}) => ({
  showModule1: shouldShowModuleCard({
    moduleValue: ENTERPRISE_ADLE_MODULE_VALUES.CREATIVE_ASSETS,
    fieldPrefix:
      MODULE_VALUE_TO_PREFIX[ENTERPRISE_ADLE_MODULE_VALUES.CREATIVE_ASSETS],
    selectedModules: selectedAdleModules,
    formValues,
    readOnly,
  }),
  showModule2: shouldShowModuleCard({
    moduleValue: ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_LAUNCH,
    fieldPrefix:
      MODULE_VALUE_TO_PREFIX[ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_LAUNCH],
    selectedModules: selectedAdleModules,
    formValues,
    readOnly,
  }),
  showModule3: shouldShowModuleCard({
    moduleValue: ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_IMPORT,
    fieldPrefix:
      MODULE_VALUE_TO_PREFIX[ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_IMPORT],
    selectedModules: selectedAdleModules,
    formValues,
    readOnly,
  }),
  showModule4: shouldShowModuleCard({
    moduleValue: ENTERPRISE_ADLE_MODULE_VALUES.ORGANIC_SOCIAL,
    fieldPrefix:
      MODULE_VALUE_TO_PREFIX[ENTERPRISE_ADLE_MODULE_VALUES.ORGANIC_SOCIAL],
    selectedModules: selectedAdleModules,
    formValues,
    readOnly,
  }),
});
